import { render, staticRenderFns } from "./Acordeon.vue?vue&type=template&id=8b098cb6"
import script from "./Acordeon.vue?vue&type=script&lang=js"
export * from "./Acordeon.vue?vue&type=script&lang=js"
import style0 from "./Acordeon.vue?vue&type=style&index=0&id=8b098cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports